var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImg = function SvgImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 165,
    viewBox: "0 0 292 165",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.8356 127.266H53.4046C49.705 123.86 47.3459 118.703 47.3459 112.93V108.689C47.3459 96.4002 38.4261 86.4381 27.4227 86.4381C16.1438 86.4381 6.9996 76.2256 6.9996 63.6287C6.9996 51.0317 16.1428 40.8192 27.4227 40.8192H30.769C41.7724 40.8192 50.6922 30.8572 50.6922 18.5687C50.6922 8.31289 58.1357 0 67.3173 0H197.217C207.436 0 215.721 9.25232 215.721 20.6664C215.721 28.4687 211.849 35.2605 206.134 38.7777H228.952C238.468 38.7777 246.182 46.7515 246.182 56.5874C246.182 68.3751 255.427 77.93 266.831 77.93H270.298C281.99 77.931 291.467 87.7265 291.467 99.8099C291.467 111.893 281.99 121.689 270.3 121.689C258.896 121.689 249.651 131.245 249.651 143.031V147.101C249.651 156.937 241.937 164.91 232.421 164.91H152.242C151.637 164.968 151.025 165 150.405 165H18.8376C8.43356 165 -3.05176e-05 156.553 -3.05176e-05 146.133C-0.00100708 135.713 8.43262 127.266 18.8356 127.266Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100 117.642L145.702 144L191.404 117.642L145.702 91.2845L100 117.642Z",
    fill: "#031FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M100 110.578L145.702 136.936L191.404 110.578L145.702 84.2207L100 110.578Z",
    fill: "#031FEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100.073L145.702 126.431L191.404 100.073L145.702 73.7155L100 100.073Z",
    fill: "#E4EAF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.655 67.741C137.809 67.741 139.556 69.4873 139.556 71.6415C139.556 72.3085 139.388 72.9364 139.093 73.4854L142.932 78.0599C143.939 77.4813 145.107 77.1505 146.351 77.1505C147.567 77.1505 148.709 77.4659 149.7 78.0194L156.281 70.1762L158.252 71.8304L151.673 79.6717C152.645 80.8575 153.228 82.374 153.228 84.0267C153.228 85.51 152.758 86.8836 151.959 88.0069L156.38 92.585C156.897 92.3318 157.479 92.1896 158.093 92.1896C160.248 92.1896 161.994 93.936 161.994 96.0902C161.994 98.2444 160.248 99.9907 158.093 99.9907C155.939 99.9907 154.193 98.2444 154.193 96.0902C154.193 95.4905 154.328 94.9225 154.57 94.415L150.104 89.79C149.025 90.4938 147.736 90.9029 146.351 90.9029C144.654 90.9029 143.101 90.288 141.901 89.2688L138.064 92.2665C138.197 92.659 138.269 93.0794 138.269 93.5166C138.269 95.6708 136.523 97.4172 134.368 97.4172C132.214 97.4172 130.468 95.6708 130.468 93.5166C130.468 91.3624 132.214 89.6161 134.368 89.6161C135.147 89.6161 135.872 89.8443 136.481 90.2374L140.285 87.2659C139.768 86.3007 139.475 85.1979 139.475 84.0267C139.475 82.4036 140.038 80.9118 140.978 79.7356L137.195 75.2265C136.722 75.4296 136.202 75.542 135.655 75.542C133.501 75.542 131.755 73.7957 131.755 71.6415C131.755 69.4873 133.501 67.741 135.655 67.741ZM158.093 94.8034C157.383 94.8034 156.807 95.3795 156.807 96.0902C156.807 96.8008 157.383 97.3769 158.093 97.3769C158.804 97.3769 159.38 96.8008 159.38 96.0902C159.38 95.3795 158.804 94.8034 158.093 94.8034ZM134.368 92.2299C133.658 92.2299 133.082 92.806 133.082 93.5166C133.082 94.2273 133.658 94.8034 134.368 94.8034C135.079 94.8034 135.655 94.2273 135.655 93.5166C135.655 92.806 135.079 92.2299 134.368 92.2299ZM146.351 80.0457C144.153 80.0457 142.371 81.8281 142.371 84.0267C142.371 86.2253 144.153 88.0076 146.351 88.0076C148.55 88.0076 150.332 86.2253 150.332 84.0267C150.332 81.8281 148.55 80.0457 146.351 80.0457ZM135.655 70.3547C134.945 70.3547 134.368 70.9308 134.368 71.6415C134.368 72.3522 134.945 72.9283 135.655 72.9283C136.366 72.9283 136.942 72.3522 136.942 71.6415C136.942 70.9308 136.366 70.3547 135.655 70.3547Z",
    fill: "#031FEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.777 63.8807C155.934 63.8807 153.63 66.1852 153.63 69.0278C153.63 71.8705 155.934 74.1749 158.777 74.1749C161.62 74.1749 163.924 71.8705 163.924 69.0278C163.924 66.1852 161.62 63.8807 158.777 63.8807ZM158.777 66.776C160.021 66.776 161.029 67.7842 161.029 69.0278C161.029 70.2715 160.021 71.2797 158.777 71.2797C157.533 71.2797 156.525 70.2715 156.525 69.0278C156.525 67.7842 157.533 66.776 158.777 66.776Z",
    fill: "#031FEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.702 126.431V73.7155L100 47.3577V100.073L145.702 126.431Z",
    fill: "url(#paint1_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.878 126.431V73.7155L191.404 47.3577V100.073L145.878 126.431Z",
    fill: "url(#paint2_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M100 47.3578L145.702 73.7155L191.404 47.3578L145.702 21L100 47.3578Z",
    fill: "url(#paint3_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.473,
    y1: 150,
    x2: 236.621,
    y2: 81.8767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 100,
    y1: 86.8944,
    x2: 145.702,
    y2: 86.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9056.68,
    y1: 6967.06,
    x2: 1216.52,
    y2: 14111.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.702 47.3578) scale(37.3165 37.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF",
    stopOpacity: 0.2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img.bcb56119.svg";
export { ForwardRef as ReactComponent };